import React, { useContext } from 'react'
import { NavContext } from '../providers/NavProvider'
import { StaticImage } from 'gatsby-plugin-image'
import { useWindowSize } from '../hooks/useWindowSize'

import * as styles from '../styles/background.module.scss'

const Background = ({ setComps }) => {
    const size = useWindowSize()
    const [nav, setNav] = useContext(NavContext)

    return (
        <div
            style={{
                width: '100%',
                height: '100vh',
                position: 'fixed',
                zIndex: -1,
                margin: 0,
                padding: 0,
                top: 0,
                left: 0,
            }}
            onClick={() => {
                console.log("clicking background")
                setNav(state => ({ ...state, showIndex: true }))
            }}
        >
            {size.width > 768
                ? (
                    <StaticImage
                        src="../images/back-logo-lg.png"
                        alt="transparent logo"
                        style={{
                            position: "relative",
                            zIndex: 2,
                            height: '100vh'
                        }}
                        placholder="tracedSVG"
                        layout="fullWidth"
                    />
                ) : (
                    <StaticImage
                        src="../images/back-logo-sm.png"
                        alt="transparent logo"
                        style={{
                            position: "relative",
                            zIndex: 2,
                            height: '100vh'
                        }}
                        placholder="tracedSVG"
                        layout="fullWidth"
                    />
                )
            }

                <StaticImage 
                        src="../images/back_flower.jpg"
                        alt="mobile background with Pallesium" 
                        style={{ 
                            position: 'unset',
                            zIndex: 1
                        }}
                        className={styles.picture_two}
                        placeholder="tracedSVG"
                        layout="fullWidth"
                />
                <StaticImage
                    className={styles.picture_one}
                    src="../images/back_blank.jpg"
                    alt="desktop background with Pallesium" 
                    style={{ 
                        position: 'unset',
                        zIndex: 2
                    }}
                    placeholder="tracedSVG"
                    layout="fullWidth"
                />
        </div>
    )
}

export default Background